import * as actionTypes from '../actionTypes/collectionPage';

export function getCollectionPageData(url) {
  return { type: actionTypes.COLLECTION_PAGE_DATA_LOAD, url };
}

export function updateCollectionRenderData(data) {
  return { type: actionTypes.COLLECTION_PAGE_RENDER_DATA_UPDATE, data };
}

export function updateCollectionData(data) {
  return { type: actionTypes.COLLECTION_MERGED_DATA_UPDATE, data };
}
